<template>
  <div id="app">
    <nav v-if="currentUser" class="navbar navbar-expand navbar-dark bg-lodi">
      <a href class="navbar-brand" @click.prevent>Picko</a>
      <div class="navbar-nav mr-auto">
        <li class="nav-item">
          <router-link to="/home" class="nav-link">
            <font-awesome-icon icon="home" />Home
          </router-link>
        </li>
        <li v-if="showAdminBoard" class="nav-item">
          <router-link to="/admin" class="nav-link">Admin Board</router-link>
        </li>
        <li class="nav-item">
          <router-link v-if="currentUser" to="/do" class="nav-link">Daftar DO</router-link>
        </li>
        <!--
        <li class="nav-item">
          <router-link v-if="currentUser" to="/picklist-open" class="nav-link">Open Picklist</router-link>
        </li>
        <li class="nav-item">
          <router-link v-if="currentUser" to="/picklist" class="nav-link">Daftar Picklist</router-link>
        </li>
        -->
      </div>

      <div v-if="!currentUser" class="navbar-nav ml-auto">
        <li class="nav-item">
          <router-link to="/login" class="nav-link">
            <font-awesome-icon icon="sign-in-alt" />Login
          </router-link>
        </li>
      </div>

      <div v-if="currentUser" class="navbar-nav ml-auto">
        <li class="nav-item">
          <router-link to="/profile" class="nav-link">
            <font-awesome-icon icon="user" />
            {{ currentUser.username }}
          </router-link>
        </li>
        <li class="nav-item">
          <a class="nav-link" href @click.prevent="logOut">
            <font-awesome-icon icon="sign-out-alt" />LogOut
          </a>
        </li>
      </div>
    </nav>
    <div class="containerx">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    showAdminBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes('ROLE_ADMIN');
      }

      return false;
    },
  },
  methods: {
    logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    }
  }
};
</script>

<style>
.page-main {
  /* max-width: 350px !important; */
  margin-left: 30px;
  width: 96%;
}

.bg-lodi {
  background-color: #082953;
}
</style>